module.exports = __webpack_public_path__ + "img/5_95.3a99adc1.png";